import { createApi } from "@reduxjs/toolkit/query/react";
import { endPoints, urlKeys } from "../../api";
import { baseQuery } from "./baseQuery";
import { formatString } from "../../utils/urlFormatting";

export const sitesQuery = createApi({
  baseQuery,
  reducerPath: "sitesQueries",
  endpoints: (builder) => ({
    createSite: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.sites.create)}`,
        method: "POST",
        body: data,
      }),
    }),
    getAllSites: builder.mutation<any, any>({
      query: ({
        study_id,
        from = 0,
        size = -1,
        value = "",
        sort_by = "",
        sort_order = "",
        data,
      }) => ({
        url: `${formatString(endPoints.sites.getAll, {
          key: urlKeys.study_id,
          value: encodeURIComponent(study_id),
        })}?from=${from}&size=${size}${
          value && `&value=${encodeURIComponent(value)}`
        }${sort_by && `&sort_by=${sort_by}`}${
          sort_order && `&sort_order=${sort_order}`
        }`,
        method: "POST",
        body: data,
      }),
    }),
    updateSite: builder.mutation<any, any>({
      query: ({ data }) => ({
        url: `${formatString(endPoints.sites.update)}`,
        method: "PUT",
        body: data,
      }),
    }),
    deleteSite: builder.mutation<any, any>({
      query: ({ study_id, site_id }) => ({
        url: `${formatString(
          endPoints.sites.delete,
          {
            key: urlKeys.study_id,
            value: encodeURIComponent(study_id),
          },
          {
            key: urlKeys.site_id,
            value: site_id,
          }
        )}`,
        method: "DELETE",
      }),
    }),
    siteDetails: builder.query<any, any>({
      query: ({ study_id, site_id }) => ({
        url: `${formatString(
          endPoints.sites.select,
          {
            key: urlKeys.study_id,
            value: encodeURIComponent(study_id),
          },
          {
            key: urlKeys.site_id,
            value: site_id,
          }
        )}`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useCreateSiteMutation,
  useGetAllSitesMutation,
  useUpdateSiteMutation,
  useDeleteSiteMutation,
  useLazySiteDetailsQuery,
} = sitesQuery;
